import React, { useEffect, useRef, useState, useCallback } from "react";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import VisibilityIcon from "@material-ui/icons/Visibility";
import user from "../../assets/images/user.svg";
import email from "../../assets/images/email.svg";
import phone from "../../assets/images/phone.svg";
import key from "../../assets/images/key.svg";
import calendar from "../../assets/images/calendar.png";
import ErrorState from "./components/errorState";
import FileBrowser from "./components/fileBrowser";
import SubHeader from "./components/subHeader";
import logoText from "../../assets/images/logoText.svg";
import logo from "../../assets/images/brandIcon.svg";
import iIcon from "../../assets/images/iIcon.svg";
import back from "../../assets/images/back.svg";
import img from "../../assets/images/3-4.svg.svg";
import { callApi, decrementStep } from "../../../redux/action/action";
import { useHistory, Link } from "react-router-dom";

import DatePicker from "react-datepicker";
import $ from "jquery";
import { agreementData } from "../../../constants/otherConstans";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { axiosInstance } from "../../../config/axiosConfig";
import Loader from "../../modals/Loader";
import { HeaderComp } from "./headerComp";
import Doctor from "../../assets/images/signupImageWeb.png";
import DoctorMobile from "../../assets/images/doctorMobile.png";
import dropIcon from "../../assets/images/dropDownIcon.svg";
import uncheck from "../../assets/images/uncheckBox.svg";
import checkBox from "../../assets/images/chekedbox.svg";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./staffSignUp_3.css";
import Select from "react-select";
import {
  showSuccessToast,
  showErrorToast,
} from "../../common/toastMeassage/ToastMeassage";
import StaffSignUp_4 from "./staffSignUp_4";
import CustomSelect from "../../ui/CustomSelect";

function StaffSignUp_3(props) {
  const history = useHistory();
  const datePickerRef = useRef(null);
  const [fullName, setFullName] = useState("");
  const [dob, setDob] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [psw, setPsw] = useState("");
  const [repsw, setRepsw] = useState("");
  const [file, setFile] = useState("");
  const [fileTitleErr, setFileTitleErr] = useState(
    "The PDF, DOCX file is required."
  );
  const [fileAdded, setFileAdded] = useState(false);
  const [uploadedFileUrl, setUploadedFileUrl] = useState(null);
  const [professionalStatus, setProfessionalStatus] = useState(null);
  const [specializationOption, setSpecializationOption] = useState([]);
  const [showSepcializatonOther, setSpecializationOther] = useState(false);
  const [showfunctionalOther, setShowfunctionalOther] = useState(false);
  const [selectedProfessionalStatus, setSelectedProfessionalStatus] =
    useState("");

  const [functionalArea, setFunctionalArea] = useState(null);
  const [specialization, setSpecialization] = useState(null);
  const [functionalAreaOptions, setFunctionalAreaOptions] = useState([]);
  const [specializationOptions, setSpecializationOptions] = useState([]);
  const [functionalAreaOtherValue, setFunctionalAreaOtherValue] = useState("");
  const [specializationOtherValue, setSpecializationOtherValue] = useState("");
  const [professionalStatusOptions, setProfessionalStatusOptions] = useState(
    []
  );
  const [isEmailAvailable, setIsEmailAvailable] = useState(true);
  const [error, setError] = useState({
    fullName: "none",
    dob: "none",
    email: "none",
    phone: "none",
    psw: "none",
    repsw: "none",
    file: "none",
  });
  const [jobTitle, setJobTitle] = useState("");
  const [jobTitleErr, setJobTitleErr] = useState("Job Title is required");
  const [pswErr, setPswErr] = useState("Password is required");
  const [emailErr, setEmailErr] = useState("Valid email address is required.");
  const [showLoader, setShowLoader] = useState(false);
  const [imgUrl, setImgUrl] = useState("");
  const [croppedImgUrl, setCroppedImgUrl] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(true);
  const [isMedicalAgreementAccepted, setIsMedicalAgreementAccepted] =
    useState(true);
  const [selectedFunctionalArea, setSelectedFunctionalArea] = useState("");
  const [selectedSpecialization, setSelectedSpecialization] = useState("");

  useEffect(() => {
    if (props.formData?.contactDetails) {
      const {
        fullName: fn,
        dob: d,
        email: em,
        phone: ph,
        psw: pw,
        repsw: rpw,
        file: f,
        jobTitle: jt,
      } = props.formData.contactDetails;
      setFullName(fn || "");
      setDob(d || "");
      setEmail(em || "");
      setPhone(ph || "");
      setPsw(pw || "");
      setRepsw(rpw || "");
      setFile(f || null);
      setJobTitle(jt || "");
      setShowLoader(false);
    }
    fetchFunctionalAreas();
    fetchProfessionalStatuses();
  }, []);

  const handleCalendarIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const togglePassword = (id) => {
    let input = $("#" + id);
    if (input.attr("type") === "password") {
      input.attr("type", "text");
      $("#c_" + id).hide();
      $("#o_" + id).show();
    } else {
      input.attr("type", "password");
      $("#o_" + id).hide();
      $("#c_" + id).show();
    }
  };

  const handleName = (e) => {
    const inputText = e.target.value;
    const pattern = /^[A-Za-z\s]*$/;
    if (pattern.test(inputText)) {
      setFullName(inputText);
      if (inputText !== "") {
        setError((prev) => ({ ...prev, fullName: "none" }));
      }
    }
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleDOB = (e) => {
    if (!e) {
      setDob("");
      return;
    }
    const formattedDate = formatDate(e);
    setDob(formattedDate);
    if (formattedDate !== "") {
      setError((prev) => ({ ...prev, dob: "none" }));
    }
  };

  const validateDOB = (dob) => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dob)) return false;
    const parsedDate = new Date(dob);
    if (isNaN(parsedDate.getTime())) return false;
    return true;
  };

 const handleEmail = async (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);

    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/;
    const isValidFormat = re.test(String(emailValue).toLowerCase());

    if (!isValidFormat) {
      setError((prev) => ({ ...prev, email: "block" }));
      setEmailErr("Valid email address is required.");
      setIsEmailAvailable(false);
      return;
    }

    await emailRepeatCheck(emailValue);
  };

  const handleJobTitle = (e) => {
    const jobTitleValue = e.target.value;
    setJobTitle(jobTitleValue);
    setError((prev) => ({
      ...prev,
      jobTitle: jobTitleValue !== "" ? "none" : "block",
    }));
  };

  const handlePhone = (value) => {
    const digitsOnly = value.replace(/\D/g, "");
    const isValid = digitsOnly.length === 11;
    setPhone(value);
    setError((prev) => ({
      ...prev,
      phone: isValid ? "none" : "block",
    }));
  };

  const handlePsw = (e) => {
    const passwordValue = e.target.value;
    setPsw(passwordValue);
    if (passwordValue.length === 0) {
      setPswErr("Password is required.");
      setError((prev) => ({ ...prev, psw: "block" }));
      return;
    } else {
      if (passwordValue.length < 6) {
        setPswErr(
          "Password should have minimum 6 characters, 1 upper case,  1 lower case, 1 special character and 1 number."
        );
        setError((prev) => ({ ...prev, psw: "block" }));
      } else {
        var mached = [];
        mached.push("[$@$!%*#?&]");
        mached.push("[A-Z]");
        mached.push("[0-9]");
        mached.push("[a-z]");
        var ctr = 0;
        for (var i = 0; i < mached.length; i++) {
          if (new RegExp(mached[i]).test(passwordValue)) {
            ctr++;
          }
        }
        if (ctr < 4) {
          setPswErr(
            "Password should have minimum 6 characters, 1 upper case,  1 lower case, 1 special character and 1 number."
          );
          setError((prev) => ({ ...prev, psw: "block" }));
        } else {
          setError((prev) => ({ ...prev, psw: "none" }));
        }
      }
      if (repsw !== "") {
        if (repsw === passwordValue) {
          setError((prev) => ({ ...prev, repsw: "none" }));
        } else {
          setError((prev) => ({ ...prev, repsw: "block" }));
        }
      }
    }
  };
  const handleSpecializationOtherChange = (value) => {
    setSpecializationOtherValue(value);
    // setErrors((prevErrors) => ({
    //   ...prevErrors,
    //   specialization:
    //     value.trim() === "" ? "Error: Specialization is required" : "",
    // }));
  };
  const handleFunctionalOtherChange = (value) => {
    setFunctionalAreaOtherValue(value);
    // setErrors((prevErrors) => ({
    //   ...prevErrors,
    //   functional:
    //     value.trim() === "" ? "Error: Functional Area is required" : "",
    // }));
  };
  const validatePassword = (password) => {
    if (password.length < 8) return false;
    return true;
  };

  const handleRepsw = (e) => {
    const rePasswordValue = e.target.value;
    setRepsw(rePasswordValue);
    if (rePasswordValue !== "" && psw === rePasswordValue) {
      setError((prev) => ({ ...prev, repsw: "none" }));
    } else if (rePasswordValue === "" && psw === "") {
      setError((prev) => ({ ...prev, repsw: "none" }));
    } else {
      setError((prev) => ({ ...prev, repsw: "block" }));
    }
  };

  const isPasswordMatch = (psw, repsw) => {
    return psw === repsw;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return emailRegex.test(email);
  };

  const validateForm = () => {
    let valid = true;
    let errorCopy = { ...error };

    if (fullName.trim() === "") {
      errorCopy.fullName = "block";
      valid = false;
    }
    if (dob && !validateDOB(dob)) {
      errorCopy.dob = "block";
      valid = false;
    }
    if (email === "" || !validateEmail(email)) {
      errorCopy.email = "block";
      valid = false;
    }
    if (!validatePassword(psw)) {
      errorCopy.psw = "Password does not meet the criteria.";
      valid = false;
    }
    if (!isPasswordMatch(psw, repsw)) {
      errorCopy.repsw = "Passwords do not match.";
      valid = false;
    }
    if (functionalArea === "") {
      errorCopy.functionalArea = "block";
      valid = false;
    }
    if (specialization === "") {
      errorCopy.specialization = "block";
      valid = false;
    }
    if (professionalStatus === "") {
      errorCopy.professionalStatus = "block";
      valid = false;
    }
    if (psw === "") {
      errorCopy.psw = "block";
      valid = false;
    }
    setError(errorCopy);
    setShowErrors(true);
    return valid;
  };

  const onNextClick = async () => {
  };

  const handleTermsCheckboxToggle = () => setIsTermsAccepted((prev) => !prev);

  const handleMedicalAgreementCheckboxToggle = () =>
    setIsMedicalAgreementAccepted((prev) => !prev);

  const isFormValid = () => {
    const allFieldsFilled =
      fullName &&
      validateEmail(email) &&
      psw &&
      repsw &&
      isPasswordMatch(psw, repsw) &&
      selectedFunctionalArea &&
      selectedSpecialization &&
      selectedProfessionalStatus &&
      isTermsAccepted &&
      isMedicalAgreementAccepted &&
      isEmailAvailable &&
      // ADD THESE:
      (selectedFunctionalArea !== "Other" ||
        (selectedFunctionalArea === "Other" &&
          functionalAreaOtherValue.trim())) &&
      (selectedSpecialization !== "Other" ||
        (selectedSpecialization === "Other" &&
          specializationOtherValue.trim()));
    return allFieldsFilled;
  };

 const emailRepeatCheck = async (emailVal) => {
    try {
      const data = { email: emailVal || email };
      const [res1, res2, res3] = await Promise.all([
        callApi("POST", "v1/LHS/hospital/emailCheck", null, data),
        callApi("POST", "v1/LHS/staff/emailCheck", null, data),
        callApi("POST", "v1/LHS/admin/emailCheck", null, data),
      ]);
      const isAvailable =
        res1.result === "OK" && res2.result === "OK" && res3.result === "OK";
      setIsEmailAvailable(isAvailable);
      setError((prev) => ({
        ...prev,
        email: isAvailable ? "none" : "block",
      }));
      setEmailErr(isAvailable ? "" : "This Email address is already in use.");
      return isAvailable;
    } catch {
      setIsEmailAvailable(false);
      setError((prev) => ({ ...prev, email: "block" }));
      setEmailErr("Error checking email availability.");
      return false;
    }
  };


  const fetchFunctionalAreas = async () => {
    try {
      const res = await axiosInstance.get("v2/LHS/User/functional-areas");
      if (res?.data) {
        const functionalAreas = res.data.data || [];

        setFunctionalAreaOptions(
          functionalAreas.map((item) => ({
            label: item.name,
            value: item._id,
          }))
        );
      }
    } catch {}
  };

  const fetchSpecializations = async (functionalAreaId) => {
    try {
      const res = await callApi(
        "GET",
        `v2/LHS/User/specializations/${functionalAreaId}`
      );
      if (res?.data) {
        setSpecializationOption(
          (res.data || []).map((item) => ({
            label: item.name,
            value: item._id,
          }))
        );
      }
    } catch {}
  };

  const fetchProfessionalStatuses = async () => {
    try {
      const res = await callApi("GET", "v2/LHS/User/professional-status");
      if (res?.data) {
        setProfessionalStatusOptions(res.data || []);
      }
    } catch {
      setProfessionalStatusOptions([]);
    }
  };

  const handleInstructionsClick = () => setShowInstructions(true);
  const handleCloseInstructions = () => setShowInstructions(false);

  const handleDropdownChange = (val) => {
    setSelectedFunctionalArea(val);

    if (val === "Other") {
      setShowfunctionalOther(true);
      setSpecializationOption([]);
      setSelectedSpecialization(val);
      setSpecializationOther(true);
    } else {
      setShowfunctionalOther(false);

      // Find the selected functional area object
      const selectedArea = functionalAreaOptions.find((item) => {
        console.log("Checking item:", item.label, "against value:", val);
        return item.label === val;
      });

      if (selectedArea) {
        fetchSpecializations(selectedArea.value);
      }
    }

    // let selectedOption = null;
    // if (field === "functionalArea") {
    //   selectedOption = functionalAreaOptions.find((opt) => opt._id === id);
    //   fetchSpecializations(id);
    //   setFunctionalArea(selectedOption);
    // } else if (field === "specialization") {
    //   selectedOption = specializationOptions.find((opt) => opt._id === id);
    //   setSpecialization(selectedOption);
    // } else if (field === "professionalStatus") {
    //   selectedOption = professionalStatusOptions.find((opt) => opt._id === id);
    //   setProfessionalStatus(selectedOption);
    // }
  };

  const handleBack = () => history.goBack();

  if (showInstructions) {
    return (
      <StaffSignUp_4
        handleCloseInstructions={handleCloseInstructions}
        fullName={fullName}
      />
    );
  }

  return (
    <>
      <div
        className="d-flex h-screen justify-center"
        style={{ height: "100vh" }}
      >
        <div className="flex gap-[100px] items-center w-full px-4 md:!px-7 justify-center  max-w-[1440px]  ">
          <div className="w-full  md:w-[50%]  hidden  lg:flex justify-end items-center   ">
            <div className="   max-w-[720px] ">
              {" "}
              <img
                alt="img"
                src={Doctor}
                className="logInLogo"
                style={{ width: "100%", height: "94vh" }}
              />
            </div>
          </div>
          <div className="max-h-[90vh] h-auto w-full md:w-[50%]  px-0   ssu_container    flex   ">
            <div className="  px-4  lg:px-5 xl:px-0  flex flex-col items-center w-full ">
              <div className="flex flex-col items-center justify-center w-full  mt-4">
                <div className="flex items-center justify-center  gap-2  md:gap-4  relative  w-full">
                  <img
                    alt="img"
                    src={back}
                    className="brandLogo absolute left-0 hidden md:block cursor-pointer
                          "
                    onClick={handleBack}
                  />
                  <img alt="img" src={logo} className="brandLogo" />
                  <img alt="img" src={logoText} className="logInLogo" />
                </div>
                <div className=" lg:hidden mt-4  flex items-center justify-center ">
                  <img
                    alt="img"
                    src={DoctorMobile}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex items-center  flex-col justify-center gap-7">
                  <div className="logIn_txt1 font-semibold text-2xl mt-4 font-inter ">
                    Create Account
                  </div>
                </div>
                <div className="font-inter text-xl font-normal text-center mt-4 max-w-[500px]">
                  Please provide your contact details
                </div>
              </div>
              <div className="flex flex-col gap-2   w-full">
                <div className="ssu2_modal1_input py-1 mt-2">
                  <p className="inputLabel flex pb-1">
                    {" "}
                    Full Name <p className="ml-1 text-red-700 ">*</p>
                  </p>
                  <div className="ssu2_modal1_input py-1 ssu2_modal3_selectBox">
                    <input
                      className="ssu2_modal3_select"
                      placeholder="Enter your full name"
                      type="text"
                      value={fullName}
                      onChange={handleName}
                      onKeyDown={(e) => {
                        if (
                          ((e.keyCode > 47 && e.keyCode < 58) ||
                            (e.keyCode > 95 && e.keyCode < 107)) &&
                          e.keyCode !== 8 &&
                          e.keyCode !== 9 &&
                          e.keyCode !== 32
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onBlur={() => {
                        emailRepeatCheck();
                      }}
                    />
                  </div>
                  <ErrorState
                    show={error.fullName}
                    name="Full Name is required."
                  />
                </div>

                <div className="ssu2_modal1_input p-0 ">
                  <p className="inputLabel flex gap-1">
                    Date of Birth{" "}
                    <p className="font-inter text-base text-[#3333334D] font-medium">
                      (Optional)
                    </p>
                  </p>
                  <div className="ssu2_modal1_input ssu2_modal3_selectBox ">
                    <div
                      className="input_left_icon z-10 cursor-pointer "
                      onClick={handleCalendarIconClick}
                    >
                      <img
                        width="18px"
                        height="15px"
                        alt="img"
                        src={calendar}
                      />
                    </div>
                    <DatePicker
                      selected={dob ? new Date(dob) : null}
                      onChange={handleDOB}
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                      className="ssu2_modal3_select pl-[10px]"
                      placeholderText="Select your date of birth"
                      maxDate={new Date()}
                      onBlur={() => {
                        emailRepeatCheck();
                      }}
                      ref={datePickerRef}
                    />
                  </div>
                  <ErrorState show={error.dob} name="DOB is required." />
                </div>

                <div className="ssu2_modal1_input p-0">
                  <p className="inputLabel flex">
                    Email Address <p className="ml-1 text-red-700 ">*</p>
                  </p>
                  <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                    <input
                      className="ssu2_modal3_select"
                      placeholder="Enter your email address"
                      type="email"
                      value={email}
                      onChange={handleEmail}
                    />
                  </div>
                  <ErrorState show={error.email} name={emailErr} />
                </div>
                <div className="ssu2_modal1_input p-0">
                  <p className="inputLabel flex gap-1">
                    Phone Number{" "}
                    <span className="font-inter text-base text-[#3333334D] font-medium">
                      (Optional)
                    </span>
                  </p>
                  <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                    <PhoneInput
                      country={"us"}
                      onlyCountries={["us"]}
                      disableDropdown={true}
                      enableAreaCodes={true}
                      countryCodeEditable={false}
                      value={phone}
                      onChange={handlePhone}
                      enableSearch={false}
                      masks={{ us: "(...) ...-...." }}
                      inputClass="custom-phone-input"
                      containerStyle={{
                        width: "100%",
                      }}
                      buttonStyle={{
                        border: "none",
                        background: "transparent",
                        marginLeft: "10px",
                        borderRight: "1px solid #ccc",
                        marginRight: "10px",
                        paddingRight: "8px",
                        marginTop: "10px", // More space on top
                        marginBottom: "10px", // More space on bottom
                        height: "calc(100% - 20px)",
                        width: "40px", // Adjusted to match reduced height
                      }}
                      dropdownStyle={{ borderRadius: "8px" }}
                    />
                  </div>
                  <ErrorState
                    show={error.phone}
                    name={"10 digits phone number is required."}
                  />
                </div>
                <div className="ssu2_modal1_input p-0">
                  <p className="inputLabel flex">
                    Password <p className="ml-1 text-red-700  ">*</p>
                  </p>
                  <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                    <input
                      id="psw"
                      className="ssu3_password"
                      placeholder="Enter your password"
                      type="password"
                      value={psw}
                      onChange={handlePsw}
                    />
                    <div
                      className="ssu3_eye"
                      onMouseDown={() => togglePassword("psw")}
                      onMouseUp={() => togglePassword("psw")}
                      onTouchStart={() => togglePassword("psw")}
                      onTouchEnd={() => togglePassword("psw")}
                    >
                      <VisibilityOffIcon
                        id="c_psw"
                        style={{ display: "block" }}
                      />
                      <VisibilityIcon id="o_psw" style={{ display: "none" }} />
                    </div>
                  </div>
                  <ErrorState
                    show={error.psw}
                    name={pswErr || "Enter strong password"}
                  />
                </div>
                <div className="ssu2_modal1_input p-0">
                  <p className="inputLabel flex">
                    Confirm Password <p className="ml-1 text-red-700 ">*</p>
                  </p>
                  <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                    <input
                      id="rpsw"
                      className="ssu3_password pr-10"
                      placeholder="Enter your confirm password"
                      type="password"
                      value={repsw}
                      onChange={handleRepsw}
                    />
                    <div
                      className="ssu3_eye"
                      onMouseDown={() => togglePassword("rpsw")}
                      onMouseUp={() => togglePassword("rpsw")}
                      onTouchStart={() => togglePassword("rpsw")}
                      onTouchEnd={() => togglePassword("rpsw")}
                    >
                      <VisibilityOffIcon
                        id="c_rpsw"
                        style={{ display: "block" }}
                      />
                      <VisibilityIcon id="o_rpsw" style={{ display: "none" }} />
                    </div>
                  </div>
                  <ErrorState
                    show={error.repsw}
                    name="Doesn't match with the password."
                  />
                </div>
                <div className="flex  flex-col  gap-2  ">
                  <div
                    className="ssu2_modal1_input p-0"
                    // style={{ marginTop: 10 }}
                  >
                    <p className="inputLabel flex ">
                      Functional Area <p className="ml-1 text-red-700 ">*</p>
                      <div className="mt-1 ml-1 relative tooltip-container">
                        <img width="14px" height="14px" alt="img" src={iIcon} />
                        <span className="tooltip-text">
                          A specific domain or department where a professional
                          performs their core job duties
                        </span>
                      </div>
                    </p>
                    <div className="w-full mt-2 flex flex-col gap-3">
                      <CustomSelect
                        options={[
                          ...functionalAreaOptions,
                          { label: "Other", value: "Other" },
                        ]}
                        selected={selectedFunctionalArea}
                        onChange={handleDropdownChange}
                        fullWidth={true}
                        fontSize="text-base font-normal font-inter"
                        placeholderFontSize="text-base font-normal font-inter"
                        className="text-base font-normal font-inter"
                      />
                      {showfunctionalOther && (
                        <section className="flex flex-col gap-2">
                          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                            <input
                              className="ssu2_modal3_select pl-5"
                              name="functional"
                              placeholder="Please enter your functional area"
                              type="text"
                              value={functionalAreaOtherValue}
                              onChange={(e) =>
                                handleFunctionalOtherChange(e.target.value)
                              }
                            />
                          </div>
                          {/* {errors.functional && (
                            <div className="flex items-start text-red-500">
                              {errors.functional}
                            </div>
                          )} */}
                        </section>
                      )}
                    </div>
                    <ErrorState
                      show={error.fullName}
                      name="Functional Area is required."
                    />
                  </div>
                  <div
                    className="ssu2_modal1_input p-0 "
                    // style={{ marginTop: 10 }}
                  >
                    <p className="inputLabel flex">
                      Specialization <p className="ml-1 text-red-700 ">*</p>
                      <div className="mt-1 ml-1 relative tooltip-container">
                        <img width="14px" height="14px" alt="img" src={iIcon} />
                        <span className="tooltip-text">
                          Specific medical field a doctor focuses on after
                          general training.
                        </span>
                      </div>
                    </p>
                    <div className="w-full mt-2 flex flex-col gap-3">
                      <CustomSelect
                        options={[
                          ...specializationOption,
                          { label: "Other", value: "Other" },
                        ]}
                        selected={selectedSpecialization}
                        onChange={(val) => {
                          setSelectedSpecialization(val);

                          setSelectedSpecialization(val);
                          if (val === "Other") {
                            setSpecializationOther(true);
                          } else {
                            setSpecializationOther(false);
                          }
                        }}
                        disabled={!selectedFunctionalArea}
                        fullWidth={true}
                        fontSize="text-base font-normal font-inter"
                        placeholderFontSize="text-base font-normal font-inter"
                        className="text-base font-normal font-inter"
                      />
                      {showSepcializatonOther && (
                        <section className="flex flex-col gap-2">
                          <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                            <input
                              className="ssu2_modal3_select pl-5"
                              name="specialization"
                              placeholder="Please enter your specialization"
                              type="text"
                              value={specializationOtherValue}
                              onChange={(e) =>
                                handleSpecializationOtherChange(e.target.value)
                              }
                            />
                          </div>
                          {/* {errors.specialization && (
                  <div className="flex items-start text-red-500">
                    {errors.specialization}
                  </div>
                )} */}
                        </section>
                      )}

                      <ErrorState
                        show={error.fullName}
                        name="Specialization is required."
                      />
                    </div>
                  </div>
                  <div
                    className="ssu2_modal1_input p-0"
                    // style={{ marginTop: 10 }}
                  >
                    <p className="inputLabel flex">
                      Current Professional Status{" "}
                      <p className="ml-1 text-red-700 ">*</p>
                      <div className="mt-1 ml-1 relative tooltip-container">
                        <img width="14px" height="14px" alt="img" src={iIcon} />
                        <span className="tooltip-text">
                          It Indicates a staff's present role or employment
                          situation in their career.
                        </span>
                      </div>
                    </p>
                    <div className="ssu2_modal1_input ssu2_modal3_selectBox">
                      <CustomSelect
                        options={[
                          ...professionalStatusOptions.map((option) => ({
                            label: option.name,
                            value: option.name,
                          })),
                        ]}
                        selected={selectedProfessionalStatus}
                        onChange={setSelectedProfessionalStatus}
                        fullWidth={true}
                        fontSize="text-base font-normal font-inter"
                        placeholderFontSize="text-base font-normal font-inter"
                        className="text-base font-normal font-inter"
                      />
                    </div>
                    <ErrorState
                      show={error.fullName}
                      name="Professional Status is required."
                    />

                    <ErrorState
                      show={error.fullName}
                      name="Professional Status is required."
                    />
                  </div>
                </div>
                <div className="flex flex-col gap-2 mt-2">
                  <div className="flex items-center gap-1 w-full text-xs sm:text-sm md:text-base whitespace-nowrap truncate">
                    <img
                      src={isTermsAccepted ? checkBox : uncheck}
                      onClick={handleTermsCheckboxToggle}
                      className="cursor-pointer flex-shrink-0 w-4 h-4"
                      alt="checkbox"
                    />
                    <span className="font-inter font-normal whitespace-nowrap truncate">
                      I provide my consent to
                    </span>
                    <span
                      onClick={() =>
                        window.open(
                          "https://linkhealthstaff.com/terms-and-conditions/",
                          "_blank"
                        )
                      }
                      className="font-semibold underline text-[#73C7A9] cursor-pointer whitespace-nowrap ml-1"
                    >
                      Terms of Service
                    </span>
                    <span className="whitespace-nowrap mx-1">&</span>
                    <span
                      onClick={() =>
                        window.open(
                          "https://linkhealthstaff.com/privacy%20policy/",
                          "_blank"
                        )
                      }
                      className="font-semibold underline text-[#73C7A9] cursor-pointer whitespace-nowrap"
                    >
                      Privacy Policy
                    </span>
                  </div>

                  <div className="flex items-center gap-1 w-full text-xs sm:text-sm md:text-base whitespace-nowrap truncate">
                    <img
                      src={isMedicalAgreementAccepted ? checkBox : uncheck}
                      onClick={handleMedicalAgreementCheckboxToggle}
                      className="cursor-pointer flex-shrink-0 w-4 h-4"
                      alt="checkbox"
                    />
                    <span className="font-inter font-normal whitespace-nowrap truncate">
                      I provide my consent to
                    </span>
                    <span
                      className="font-semibold underline text-[#73C7A9] cursor-pointer whitespace-nowrap ml-1"
                      onClick={handleInstructionsClick}
                    >
                      Medical Staff Agreement
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-5 w-full">
                <div
                  className={`logIn_button  d-flex align-items-center justify-content-center p-0 !font-inter h-[58px] ${
                    !isFormValid() ? "disabled-signup-btn !font-inter" : ""
                  }`}
                  onClick={isFormValid() ? onNextClick : null}
                >
                  {showLoader ? <Loader /> : <p className="text-base font-semibold">Sign Up</p>}
                </div>
                <p className="font-normal text-lg font-inter text-center mt-4 pb-4">
                  Already have an account?{" "}
                  <Link className="text-[#73C7A9]" to="/login">
                    Log in
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StaffSignUp_3;
